export default __webpack_public_path__ + "static/media/tenniscourt.55aa1777.jpg";